import { render, staticRenderFns } from "./authorityDistributed.vue?vue&type=template&id=f4de4df6&"
import script from "./authorityDistributed.vue?vue&type=script&lang=js&"
export * from "./authorityDistributed.vue?vue&type=script&lang=js&"
import style0 from "./authorityDistributed.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports